var map = {
	"./pawbereaved.svg": "qo18",
	"./pawgeneric.svg": "fKNh",
	"./pawlgbtq.svg": "6WUe",
	"./pawpremature.svg": "xcWD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3nrJ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bears ^\.\/paw.*\.svg$
// module id = 3nrJ
// module chunks = 1